module.exports = __webpack_public_path__ + "18c365e5feda70b3286e82acba766e38.pdf";